// @flow

import ar from './ar.json'
import en from './en.json'
import enUS from './en-US.json'
import es from './es.json'

export default { ar, en, 'en-US': enUS, 'en-us': enUS, es }
